import { render } from "./Strain.vue?vue&type=template&id=98b8529c"
import script from "./Strain.vue?vue&type=script&lang=js"
export * from "./Strain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__